import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { TimeSpan } from '../helpers/time-span';

// Range check for a "hh:mm" string, mirroring the server rule for the overtime weekly limit.
export function timeStringRangeValidator(maxHours: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    // Seconds, not getTotalHours(), so that a value below one hour still counts as positive.
    const seconds = TimeSpan.parse(control.value).getTotalSeconds();

    return seconds > 0 && seconds <= maxHours * 3600 ? null : { timeOutOfRange: true };
  };
}

export function flexibleTimeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null; // Allow null/empty if not required

    const regex = /^(\d{1,4})(?::([0-5][0-9]))?$/;
    const match = value.match(regex);

    if (!match) {
      return { invalidTimeFormat: true };
    }

    return null;
  };
}
